import { RvqPreferenceType } from "../Constants/RvqPreferenceType";
import { BaseRvqPreference } from "./BaseRvqPreference";
import { OrganizationModel } from "./OrganizationModel";

class RvqLocationPreference extends BaseRvqPreference {
    public QuebecVaccinationRegistryId: number;
    public Name: string;
    public Status: number;
    public ManagedByOrganization?: OrganizationModel;

    public constructor(init?: Partial<RvqLocationPreference>) {
        super(init);

        this.Type = RvqPreferenceType.Location;
        this.DisplayName = this.getDisplayName(init.Name, init.ManagedByOrganization?.Name);
    }

    /**
     * A comparable identifier for the RVQ entity. For example, the practitioner ID for a practitioner preference, or the medication + lot ID for a medication preference.
     */
    public get comparableRvqId(): string {
        return this.QuebecVaccinationRegistryId.toString();
    }

    private getDisplayName(name: string, organizationName: string): string {
        if (!name)
            return "";

        return `${name} (${organizationName ?? ""})`;
    }
}

export { RvqLocationPreference };
